import React from 'react'
import { DisplayCurrency, DisplayCurrencyValue } from '@utils'

/**
 * 표시 통화 훅 — `utils/DisplayCurrency` 의 값을 구독하고, 처음 마운트될 때 서버 판정을 한 번 요청한다.
 * 가격을 그리는 화면(Shop · 구매 패널 · PLS 8 제품 페이지 · Cart)과 푸터 스위치가 쓴다.
 */
export const useDisplayCurrency = (): DisplayCurrencyValue => {
	const [currency, setCurrency] = React.useState<DisplayCurrencyValue>(() =>
		DisplayCurrency.get(),
	)

	React.useEffect(() => {
		const unsubscribe = DisplayCurrency.subscribe(setCurrency)
		void DisplayCurrency.detect()
		return unsubscribe
	}, [])

	return currency
}

/**
 * 서버가 판정한 국가 훅 — 확정 전에는 `null`. 표시 통화와 같은 이벤트를 구독하고,
 * 같은 `detect()` 한 번을 공유한다(중복 요청 없음).
 *
 * 쓰는 곳: 구매 패널의 착지 원가 행. 값이 `null` 이면 **감추지 않는다** — 모르면 더 많이
 * 보여 주는 쪽으로 넘어진다.
 */
export const useGeoCountry = (): string | null => {
	const [country, setCountry] = React.useState<string | null>(() =>
		DisplayCurrency.country(),
	)

	React.useEffect(() => {
		const unsubscribe = DisplayCurrency.subscribe(() =>
			setCountry(DisplayCurrency.country()),
		)
		void DisplayCurrency.detect()
		return unsubscribe
	}, [])

	return country
}
